import { Product } from '../../lib/classes/product';
import { now } from 'moment';

export interface Job {
  id?: number;
  due_date: string;
  created_at?: string;
  updated_at?: string;
  category: number;
  category_name?: string;
  employment_type: string;
  positions: number;
  title: string;
  internal_title: string;
  description: string;
  is_published: boolean;
  is_draft: boolean;
  is_template?: boolean;
  poster_id: number;
  unit_id: number;
  unit_name?: string;
  address: string;
  currency: string;
  lon: number;
  lat: number;
  country_code: string;
  country_subdivision_code: string;
  publisher_linked_id: number;
  publisher_draft_id: number;
  publisher_published_at?: string;
  has_video_interview: boolean;
  image: string;
  point: {
    type: 'Point';
    coordinates: number[];
  };
  image_thumbnail: string;
  image_media_id: number;
  salary: number;
  salary_amount: number;
  salary_type: number;
  num_applicants?: number;
  num_new_applicants?: number;
  industry_id: number;
  education_id: number;
  job_services?: Product[];
}

const in30Days = new Date();
in30Days.setMonth(new Date().getMonth() + 1);

export const EMPTY_JOB: Job = {
  category: null,
  title: '',
  internal_title: '',
  description: '',
  poster_id: null,
  unit_id: null,
  address: '',
  employment_type: 'FULL_TIME',
  due_date: in30Days.toISOString(),
  currency: 'NOK',
  lon: null,
  lat: null,
  is_published: false,
  is_draft: true,
  is_template: false,
  country_code: null,
  country_subdivision_code: null,
  publisher_linked_id: null,
  publisher_draft_id: null,
  has_video_interview: false,
  image: '',
  image_thumbnail: '',
  point: null,
  image_media_id: null,
  salary: 1,
  salary_amount: null,
  salary_type: 0,
  industry_id: null,
  education_id: null,
  positions: 1,
};
